import React from 'react';

import { SuccessTag, ErrorTag, InfoTag } from '../../../components/Tags';
import { ReleaseNoteStatus } from '../../../Model/ReleaseNote';
import texts from './texts.json';

const getStatusTag = (status) => {
  if (status === ReleaseNoteStatus.APPROVED) return <SuccessTag>{texts.statusLabels.APPROVED}</SuccessTag>;
  if (status === ReleaseNoteStatus.REJECTED) return <ErrorTag>{texts.statusLabels.REJECTED}</ErrorTag>;
  return <InfoTag>{texts.statusLabels.PENDING}</InfoTag>;
};

export { getStatusTag };
